<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      :hideOperate="true"
      @size-change="handleSizeChange"
      @on-selection-change="selectionChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
      </div>
      <template v-slot:expand>
        <div style="margin-bottom: 20px">
          <p class="inline-p">
            当前已选择<span style="padding: 0 5px">{{ currentRow.length }}</span
            >条数据
          </p>
          <el-button style="margin-left: 20px" type="primary" @click="create"
            >创建商品</el-button
          >
          <el-button
            style="margin-left: 10px"
            type="primary"
            @click="jumpToImportPage"
            >导入</el-button
          >
          <el-button style="margin-right: 10px" @click="exportList">
            导出
          </el-button>
          <el-button
            style="margin-left: 10px"
            type="primary"
            @click="batchSendWms"
            >批量推送仓库</el-button
          >
          <el-button
            style="margin-left: 10px"
            type="primary"
            @click="batchSyncAccountBookStock"
          >
            同步账册库存
          </el-button>
        </div>
      </template>
    </customize-page>
    <el-dialog
      title="选择账册"
      width="300px"
      :visible.sync="showAccountBookSelectDialog"
    >
      <el-form
        ref="accountBookForm"
        :rules="accountBookFormRules"
        :model="accountBookFormData"
      >
        <el-form-item label="账册" prop="accountBookNo">
          <el-select
            v-model="accountBookFormData.accountBookNo"
            placeholder="请选择账册"
          >
            <el-option
              v-for="item in getAccountBookList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="doSyncAccountBookStock">
          同步账册库存
        </el-button>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="(formData.id ? '修改' : '新增') + '商品备案'"
      width="700px"
      top="5vh"
      :visible.sync="showFormDialog"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="formData"
        label-width="150px"
        :inline="true"
      >
        <el-form-item label="货主id" prop="customerId">
          <el-select v-model="formData.customerId" placeholder="请选择货主">
            <el-option
              v-for="item in getCustomerList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称" prop="skuName">
          <el-input v-model.trim="formData.skuName"></el-input>
        </el-form-item>
        <el-form-item label="外部商品编码(抖音必传)" prop="outSkuId">
          <el-input v-model.trim="formData.outSkuId"></el-input>
        </el-form-item>
        <el-form-item label="备案序号" prop="itemRecordNo">
          <el-input v-model.trim="formData.itemRecordNo"></el-input>
        </el-form-item>
        <el-form-item label="商品料号" prop="itemNo">
          <el-input
            :disabled="formData.id"
            v-model.trim="formData.itemNo"
          ></el-input>
        </el-form-item>
        <el-form-item label="备案条码" prop="barcode">
          <el-input v-model.trim="formData.barcode"></el-input>
        </el-form-item>
        <el-form-item label="实物条码" prop="barcode">
          <el-input v-model.trim="formData.physicalBarcode"></el-input>
        </el-form-item>
        <el-form-item label="hscode" prop="hsCode">
          <el-input v-model.trim="formData.hsCode"></el-input>
        </el-form-item>
        <el-form-item label="商品规格" prop="gmodel">
          <el-input v-model.trim="formData.gmodel"></el-input>
        </el-form-item>
        <el-form-item label="申报计量单位代码" prop="unit">
          <el-input v-model.trim="formData.unit"></el-input>
        </el-form-item>
        <el-form-item label="法定计量单位代码" prop="unit1">
          <el-input v-model.trim="formData.unit1"></el-input>
        </el-form-item>
        <el-form-item label="法定第一数量" prop="unit1Value">
          <el-input v-model.trim="formData.unit1Value"></el-input>
        </el-form-item>
        <el-form-item label="法定第二单位代码" prop="unit2">
          <el-input v-model.trim="formData.unit2"></el-input>
        </el-form-item>
        <el-form-item label="法定第二数量" prop="unit2Value">
          <el-input v-model.trim="formData.unit2Value"></el-input>
        </el-form-item>
        <el-form-item label="原产国代码" prop="countryCode">
          <el-input v-model.trim="formData.countryCode"></el-input>
        </el-form-item>
        <el-form-item label="申报单价" prop="declareUnitPrice">
          <el-input v-model.trim="formData.declareUnitPrice"></el-input>
        </el-form-item>
        <el-form-item label="币值" prop="currency">
          <el-input v-model.trim="formData.currency"></el-input>
        </el-form-item>
        <el-form-item label="毛重(kg)" prop="grossWeight">
          <el-input v-model.trim="formData.grossWeight"></el-input>
        </el-form-item>
        <el-form-item label="净重(kg)" prop="netWeight">
          <el-input v-model.trim="formData.netWeight"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="formData.remark"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="reCustomsDeclare.title"
      width="36%"
      :visible.sync="reCustomsDeclare.isReApply"
    >
      <div slot="title">
        <div style="float: left" v-text="reCustomsDeclare.title"></div>
        <div
          style="float: right; margin-right: 8%"
          v-text="reCustomsDeclare.msg"
        ></div>
      </div>
      <el-table :data="reCustomsDeclare.currentReApplyData">
        <el-table-column
          align="center"
          property="skuName"
          label="商品名称"
          min-width="250"
        ></el-table-column>
        <el-table-column
          align="center"
          property="state"
          label="状态"
          min-width="150"
        ></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              @click="reApplyCustoms(reCustomsDeclare.type, scope.row)"
              type="text"
              size="small"
            >
              重试
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import declareApi from "@/api/declare";
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";
import { CONST_VD_IMGPREFIX } from "@/config/constant";

import { mapActions, mapGetters } from "vuex";
import { isBarcodeValid } from "../../utils/barcode";
import moment from "moment";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  mounted() {
    this.fetch();
  },
  data() {
    return {
      uploadData: {
        _aid: 401,
      },
      showFormDialog: false,
      formData: {},
      accountBookFormData: {},
      uploadName: "CPRODUCT_IMG.xlsx",
      loading: false,
      dataList: [],
      showAccountBookSelectDialog: false,
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        {
          title: "外部商品编码",
          key: "outSkuId",
          width: 150,
          align: "center",
        },
        {
          title: "货主id",
          key: "customerId",
          width: 100,
          align: "center",
        },
        {
          title: "商品名称(中文)",
          key: "skuName",
          width: 200,
          align: "center",
        },
        {
          title: "备案序号",
          key: "itemRecordNo",
          width: 100,
          align: "center",
        },
        {
          title: "商品料号",
          key: "itemNo",
          width: 100,
          align: "center",
        },
        {
          title: "备案条码",
          key: "barcode",
          width: 100,
          align: "center",
        },
        {
          title: "实物条码",
          key: "physicalBarcode",
          width: 100,
          align: "center",
        },
        {
          title: "hscode",
          width: 100,
          key: "hsCode",
          align: "center",
        },
        {
          title: "商品规格",
          width: 200,
          key: "gmodel",
          align: "center",
        },
        {
          title: "申报计量单位",
          width: 200,
          key: "unit",
          align: "center",
        },
        {
          title: "法定计量单位",
          width: 200,
          key: "unit1",
          align: "center",
        },
        {
          title: "法定第二单位",
          width: 200,
          key: "unit2",
          align: "center",
        },
        {
          title: "原产国",
          width: 200,
          key: "countryCode",
          align: "center",
        },
        {
          title: "申报单价",
          width: 120,
          key: "declareUnitPrice",
          align: "center",
        },
        {
          title: "法定第一数量",
          width: 100,
          key: "unit1Value",
          align: "center",
        },
        {
          title: "法定第二数量",
          width: 100,
          key: "unit2Value",
          align: "center",
        },
        {
          title: "币值",
          width: 100,
          key: "currency",
          align: "center",
        },
        {
          title: "毛重",
          width: 150,
          key: "grossWeight",
          align: "center",
        },
        {
          title: "净重",
          width: 150,
          key: "netWeight",
          align: "center",
        },
        {
          title: "备注",
          width: 150,
          key: "remark",
          align: "center",
        },
        {
          title: "创建时间",
          width: 160,
          key: "gmtCreate",
          align: "center",
        },
        // {
        //   title: "申报状态",
        //   width: 250,
        //   key: "declareStatus",
        //   align: "center",
        //   render: (h, param) => {
        //     let row = param.row;
        //     const tagType = {
        //       WAIT_DECLARE: ["info", "待申报"],
        //       DECLARE_SUCCESS: ["success", "申报成功"],
        //       DECLARE_FAIL: ["error", "申报失败"],
        //     };
        //     return (
        //       <div>
        //         <el-tag type={tagType[row.declareStatus][0]}>
        //           {tagType[row.declareStatus][1]}
        //         </el-tag>
        //       </div>
        //     );
        //   },
        // },
        {
          title: "状态",
          width: 150,
          key: "status",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            const tagType = {
              INIT: ["info", "待推送wms"],
              WMS_CREATE_SUCCESS: ["success", "已推送wms"],
              WMS_CREATE_EXCEPTION: ["error", "推送wms失败"],
            };
            return (
              <div>
                <el-tag type={tagType[row.status][0]}>
                  {tagType[row.status][1]}
                </el-tag>
              </div>
            );
          },
        },
        {
          title: "操作",
          width: 150,
          align: "center",
          fixed: "right",
          render: (h, param) => {
            let row = param.row;
            return (
              <div>
                <a
                  style={{ color: "#409EFF", padding: "0 10px" }}
                  onClick={this.edit.bind(this, row)}
                >
                  编辑
                </a>
                <a
                  style={{ color: "#409EFF", padding: "0 10px" }}
                  onClick={this.sendWms.bind(this, row)}
                >
                  推送仓库
                </a>
              </div>
            );
          },
        },
      ],
      filterObj: {
        customerId: "",
        skuName: "",
        itemNo: "",
        itemRecordNo: "",
        status: "",
        declareStatus: "",
        outSkuId: "",
      },
      currentRow: [],
      reCustomsDeclare: {
        msg: "",
        title: "推送",
        isReApply: false,
        currentReApplyData: [],
        successNum: 0,
        total: 0,
      },
      customsType: {
        sendWms: "sendWms",
        syncAccountBookStock: "syncAccountBookStock",
      },
      accountBookFormRules: {
        accountBookNo: [
          { required: true, message: "请选择账册", trigger: "blur" },
        ],
      },
      rules: {
        skuName: [
          { required: true, message: "请输入商品名称", trigger: "blur" },
        ],
        customerId: [
          { required: true, message: "请输入货主id", trigger: "blur" },
        ],
        itemNo: [
          { required: true, message: "请输入商品料号", trigger: "blur" },
        ],
        barcode: [
          { required: true, message: "请输入商品条码", trigger: "blur" },
        ],
        hsCode: [{ required: true, message: "请输入hscode", trigger: "blur" }],
        gmodel: [
          { required: true, message: "请输入商品规格", trigger: "blur" },
        ],
        unit: [
          {
            required: true,
            message: "请输入申报计量单位代码",
            trigger: "blur",
          },
        ],
        unit1: [
          {
            required: true,
            message: "请输入法定计量单位代码",
            trigger: "blur",
          },
        ],
        countryCode: [
          { required: true, message: "请输入原产国代码", trigger: "blur" },
        ],
        declareUnitPrice: [
          { required: true, message: "请输入申报单价", trigger: "blur" },
        ],
        unit1Value: [
          { required: true, message: "请输入法定第一数量", trigger: "blur" },
        ],
        currency: [{ required: true, message: "请输入币值", trigger: "blur" }],
        grossWeight: [
          { required: true, message: "请输入毛重(kg)", trigger: "blur" },
        ],
        netWeight: [
          { required: true, message: "请输入净重(kg)", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      getCustomerList: "getCustomerList",
      getAccountBookList: "getAccountBookList",
    }),
  },
  methods: {
    ...mapActions("goodsForRecordStore", [
      "storeDeclareGoods",
      "declareGoodsList",
      "sendWmsApi",
      "exportDeclareGoods",
    ]),
    create() {
      this.formData = {};
      this.showFormDialog = true;
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const barcodeValid = isBarcodeValid(this.formData.barcode);
          if (!barcodeValid) {
            this.$confirm("条码不合规, 是否修改成无?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.formData.barcode = "无";
                this.storeDeclareGoods(this.formData).then((res) => {
                  this.showFormDialog = false;
                });
              })
              .catch(() => {
                this.storeDeclareGoods(this.formData).then((res) => {
                  this.showFormDialog = false;
                });
              });
          } else {
            this.storeDeclareGoods(this.formData).then((res) => {
              this.showFormDialog = false;
            });
          }
        }
      });
    },
    edit(form) {
      this.formData = form;
      this.showFormDialog = true;
    },
    batchSyncAccountBookStock() {
      if (this.currentRow.length <= 0) {
        this.$message.warning("请勾选需要同步的商品");
        return;
      }
      this.showAccountBookSelectDialog = true;
    },
    doSyncAccountBookStock() {
      this.$refs["accountBookForm"].validate((valid) => {
        if (valid) {
          console.log(this.accountBookFormData);
          let list = this.showReApplyDialog(
            "同步商品",
            this.customsType.syncAccountBookStock,
            this.currentRow.length
          );
          for (let index in this.currentRow) {
            let params = {
              id: this.currentRow[index].id,
              skuName: this.currentRow[index].skuName,
              state: "请稍等",
            };
            list.push(params);
            this.reApplyCustomsHandler(
              this.syncAccountBookStockApi(
                this.currentRow[index].id,
                this.accountBookFormData.accountBookNo
              ),
              params
            );
          }
        }
      });
    },
    async syncAccountBookStockApi(declareGoodsId, accountBookNo) {
      const res = await declareApi.syncAccountBookStock({
        declareGoodsId,
        accountBookNo,
      });
      return {
        value: res.isSuccess,
      };
    },
    sendWms(row) {
      if (!row.customerId) {
        this.$message({
          message: "缺少金二备案序号，无法下发仓库",
          type: "error",
        });
        return;
      }
      this.sendWmsApi(row.id).then((res) => {
        if (res.value) {
          this.$message({
            message: "下发wms成功",
            type: "success",
          });
          this.fetch();
        } else {
          this.$message({
            message: "下发wms失败",
            type: "error",
          });
        }
      });
    },
    jumpToImportPage() {
      this.$router.push({ name: "goodsDeclareImport" });
    },
    downloadTemplate() {
      this.$message.error("旧模板原文件暂不可用，请联系管理员补充本地模板");
    },
    // 导入数据
    handleImportSuccess(res, file) {
      let fileUrl =
        CONST_VD_IMGPREFIX.prefixImgUrl + res.content[0][this.uploadName];
      this.loading = true;
      this.goodsForRecordList({
        pageIndex: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      }).then((res) => {
        console.log(res);
      });
    },
    // 分页加载退货订单列表
    fetch() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      if (filterParams.createTime != null) {
        filterParams.gmtCreateStart = moment(filterParams.createTime[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        filterParams.gmtCreateEnd = moment(filterParams.createTime[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        delete filterParams.createTime;
      }
      let searchCondition = {
        ...filterParams,
        pageIndex: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };
      this.declareGoodsList(searchCondition).then((res) => {
        this.dataList = res.items;
        this.pagination.pageIndex = res.page.pageIndex;
        this.pagination.pageSize = res.page.pageSize;
        this.pagination.totalCount = res.page.totalCount;
        this.loading = false;
      });
    },
    selectionChange(rows) {
      this.currentRow = rows;
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "货主id",
              model: "customerId",
              type: type.SELECT,
              props: {
                data: this.getCustomerList,
              },
            },
            {
              label: "外部商品编码",
              model: "outSkuId",
              type: type.INPUT,
            },
            {
              label: "商品名称",
              model: "skuName",
              placeholder: "支持模糊搜索",
              type: type.INPUT,
            },
            {
              label: "商品料号",
              model: "itemNo",
              type: type.INPUT,
            },
            {
              label: "商品备案序号",
              model: "itemRecordNo",
              type: type.INPUT,
            },
            {
              label: "申报状态",
              model: "declareStatus",
              type: type.SELECT,
              props: {
                data: [
                  {
                    value: "",
                    label: "全部",
                  },
                  {
                    value: "WAIT_DECLARE",
                    label: "待申报",
                  },
                  {
                    value: "DECLARE_SUCCESS",
                    label: "申报成功",
                  },
                  {
                    value: "DECLARE_FAIL",
                    label: "申报失败",
                  },
                ],
              },
            },
            {
              label: "商品状态",
              model: "status",
              type: type.SELECT,
              props: {
                data: [
                  {
                    value: "",
                    label: "全部",
                  },
                  {
                    value: "INIT",
                    label: "待推送wms",
                  },
                  {
                    value: "WMS_CREATE_SUCCESS",
                    label: "推送wms成功",
                  },
                  {
                    value: "WMS_CREATE_EXCEPTION",
                    label: "推送wms异常",
                  },
                ],
              },
            },
            {
              label: "创建时间",
              model: "createTime",
              type: type.DATETIME_RRANGE,
              className: "flex-form-item",
            },
          ],
        },
      ];
    },
    showReApplyDialog(title, type, total) {
      let reApplyData = [];
      this.reCustomsDeclare.total = total;
      this.reCustomsDeclare.successNum = 0;
      this.reCustomsDeclare.type = type;
      this.reCustomsDeclare.title = title;
      this.reCustomsDeclare.currentReApplyData = reApplyData;
      this.reCustomsDeclare.isReApply = !this.reCustomsDeclare.isReApply;
      return reApplyData;
    },
    batchSendWms() {
      this.$confirm("确认推送选中的商品", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        if (this.currentRow.length <= 0) {
          this.$message.warning("请勾选需要推送的商品");
          return;
        }

        let ccbStateList = this.showReApplyDialog(
          "推送商品",
          this.customsType.sendWms,
          this.currentRow.length
        );
        for (let index in this.currentRow) {
          let ccbState = {
            id: this.currentRow[index].id,
            skuName: this.currentRow[index].skuName,
            state: "请稍等",
          };
          ccbStateList.push(ccbState);
          this.reApplyCustomsHandler(
            this.sendWmsApi(this.currentRow[index].id),
            ccbState
          );
        }
      });
    },
    reApplyCustoms(type, data) {
      let result = null;
      let lastState = data.state;
      data.state = "请稍等";
      switch (type) {
        case this.customsType.sendWms:
          console.log(data);
          result = this.sendWmsApi(data.id);
          break;
        default:
          this.$message.warning("重推类型不正确，请稍后重试");
          return;
      }
      this.reApplyCustomsHandler(result, data, lastState);
    },
    reApplyCustomsHandler(reApplyCustomsPromis, data, lastState) {
      reApplyCustomsPromis
        .then((res) => {
          if (res.value) {
            if (lastState !== "成功") {
              this.reCustomsDeclare.successNum++;
            }
            data.state = "成功";
          } else {
            if (lastState === "成功") {
              this.reCustomsDeclare.successNum--;
            }
            data.state = "失败";
          }
          this.reCustomsDeclare.msg = `总共${this.reCustomsDeclare.total}条，成功${this.reCustomsDeclare.successNum}条`;
        })
        .catch((error) => {
          data.state = "异常";
        });
    },
    // 导出列表
    exportList(data) {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      if (filterParams.createTime != null) {
        filterParams.gmtCreateStart = moment(filterParams.createTime[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        filterParams.gmtCreateEnd = moment(filterParams.createTime[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        delete filterParams.createTime;
      }
      this.exportDeclareGoods({
        ...filterParams,
        currentPage: 1,
        pageSize: 9999,
      }).then((res) => {
        this.loading = false;
        if (res.value) {
          this.$alert("提交成功", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              this.$router.push({ name: "download" });
            },
          });
        } else {
          this.$message.error("提交失败");
        }
      });
    },
  },
};
</script>

<style>
.avatar-uploader {
  display: inline-block;
}
.inline-p {
  display: inline-block;
}
.inline-p span {
  color: #3399ff;
}
.filter_con.filterUp .filter-form {
  height: auto;
  overflow: visible;
}
</style>
